var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "product__statuses" }, [
    _vm.item.storage.first > _vm.elMaxView
      ? _c(
          "div",
          { staticClass: "product__status product__status_theme_green" },
          [_vm._v("\n    Ближний " + _vm._s(_vm.elMaxView) + "+\n  ")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.item.storage.first <= _vm.elMaxView && _vm.item.storage.first >= 0
      ? _c(
          "div",
          {
            staticClass: "product__status",
            class: {
              product__status_theme_green: _vm.item.storage.first > 0,
              product__status_theme_red: _vm.item.storage.first == 0,
            },
          },
          [_vm._v("\n    Ближний " + _vm._s(_vm.item.storage.first) + "\n  ")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.item.storage.second > _vm.elMaxView
      ? _c(
          "div",
          { staticClass: "product__status product__status_theme_green" },
          [_vm._v("\n    Дальний " + _vm._s(_vm.elMaxView) + "+\n  ")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.item.storage.second <= _vm.elMaxView && _vm.item.storage.second >= 0
      ? _c(
          "div",
          {
            staticClass: "product__status",
            class: {
              product__status_theme_green: _vm.item.storage.second > 0,
              product__status_theme_red: _vm.item.storage.second == 0,
            },
          },
          [_vm._v("\n    Дальний " + _vm._s(_vm.item.storage.second) + "\n  ")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.item.storage.transit > _vm.elMaxView
      ? _c(
          "div",
          { staticClass: "product__status product__status_theme_orange" },
          [
            _vm._v(
              "\n    " +
                _vm._s(_vm.item.storage.transit_date) +
                " ожидается " +
                _vm._s(_vm.elMaxView) +
                "+\n  "
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.item.storage.transit <= _vm.elMaxView && _vm.item.storage.transit > 0
      ? _c(
          "div",
          { staticClass: "product__status product__status_theme_orange" },
          [
            _vm._v(
              "\n    " +
                _vm._s(_vm.item.storage.transit_date) +
                " ожидается " +
                _vm._s(_vm.item.storage.transit) +
                "\n  "
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }